import { SelectInput } from '@framework/form';
import React from 'react';
import { ButtonType } from '../advanced/buttons/types/ButtonEnums';

export interface IButtonTypeSelectInputProps {
  name: string;
  defaultValue?: ButtonType;
  placeholder?: string;
}

export function ButtonTypeSelectInput(props: IButtonTypeSelectInputProps) {
  const { name, defaultValue, placeholder } = props;
  return (
    <SelectInput
      name={name}
      defaultValue={defaultValue}
      placeholder={placeholder}
      options={[
        {
          label: 'Primario',
          value: ButtonType.Primary,
        },
        {
          label: 'Secondario',
          value: ButtonType.Default,
        },
        {
          label: 'Come Link',
          value: ButtonType.Link,
        },
      ]}
    />
  );
}
